'use strict';

import { hasSize } from '../lib/is-mobile';




export const closeDropdown = (elem, toggle) => () => {
    toggle.classList.remove('open');
    elem.classList.remove('open');
};


const openDropdown = (elem, toggle) => evt => {
    // Prevent toggle on dropdown items
    if ( evt.target.closest('.toggle') === null ) {
        evt.preventDefault();
    }

    // Don't trigger outside click
    if ( !toggle.classList.contains('open') ) {
        evt.stopPropagation();
    }

    // Show dropdown content if there is no link clicked
    if ( (evt.target.closest('.toggle') !== null && evt.target.tagName !== 'A')
    || evt.target.closest('.toggle') === null ) {

        // Close all other open toggles
        document.querySelectorAll('.toggle.open')
            .forEach(toggle => {
                closeDropdown(
                    toggle.parentElement,
                    toggle
                )();
            });

        toggle.classList.add('open');
        toggle.style.display = 'block';

        elem.classList.add('open');
    }

    if ( (evt.target.closest('.toggle') !== null && evt.target.tagName === 'A') ) {
        evt.target.click();
        closeDropdown(elem, toggle)();
    }


    // Close dropdown on outside click
    const outsideClickListener = (event) => {
        // Remove class if the parent is not .toggle
        if ( event.target.closest('.toggle') === null ) {
            toggle.classList.remove('open');
            elem.classList.remove('open');
            removeClickListener();
        }
    };

    // Disable outside click handler
    const removeClickListener = () => {
        document.removeEventListener('mousedown', outsideClickListener);
    };

    document.addEventListener('mousedown', outsideClickListener);
};


const hideAfterClose = evt => {
    if ( evt.animationName === 'close-dropdown' ) {
        evt.target.style.display = 'none';
    }
};


export function setupClickDropdown (elem) {
    if ( !elem ) return;

    const toggle = elem.querySelector('.toggle');
    if ( !toggle ) return;


    elem.addEventListener('mousedown', openDropdown(elem, toggle));

    // Hide dropdown after close animation
    elem.addEventListener('animationend', hideAfterClose);
}


export function setupHoverDropdown (elem) {
    if ( !elem ) return;

    const toggle = elem.querySelector('.toggle');
    if ( !toggle ) return;


    let dropdownTimer;

    elem.addEventListener('mouseenter', evt => {
        dropdownTimer = window.setTimeout(() => {
            openDropdown(elem, toggle)(evt);
        }, 300);
    });

    elem.addEventListener('mouseleave', evt => {
        window.clearTimeout(dropdownTimer);
        closeDropdown(elem, toggle)(evt);
    });

    elem.addEventListener('click', evt => {
        // Disable click on label
        if ( evt.target.closest('.toggle') === null ) {
            evt.stopPropagation();
        }
    });

    // Hide dropdown after close animation
    elem.addEventListener('animationend', hideAfterClose);
}


export function resizeLoginDropdown (elem) {
    if ( !elem ) return;

    const toggle = elem.querySelector('.toggle');
    if ( !toggle ) return;


    elem.addEventListener('click', () => {
        if ( hasSize('md') ) {
            const headerHeight = document.querySelector('.main-header').offsetHeight - 5;
            const parentLeft = elem.getBoundingClientRect().left;

            toggle.style.left = `-${parentLeft}px`;
            toggle.style.top = headerHeight + 'px';
        } else {
            toggle.style.top = '100%';
            toggle.style.left = '0';
        }
    });
}
